export enum StatoRegistrazione {
    email_non_verificata = 'EMAIL_NON_VERIFICATA', 
    successo = 'SUCCESSO'
}